export const PROBE_WIDTH = 200;
export const PROBE_HEIGHT = 200;

export const ZOOM_HEIGHT = 500;
export const ZOOM_WIDTH = 500;
